export const APPLICATION_PREVIEW_URLS = {
  CHANGE_APPLICATION_STATUS:
    '/application-form/admin/update-application-status/:application_id',
  GET_SINGLE_APPLICATION_OVERVIEW: '/application-form/admin/:application_id',
  APPLICATION_REQ_OPTION_ALL: '/application/request-option/withProducts',
  UPDATE_RESPONSIBLE_PERSON: 'application-form/admin/update-responsible-person'
};
